<script setup lang="ts">
import PageBreadcrumb from '@/components/common/PageBreadcrumb.vue';
import { ref, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import axiosClient from '../axios'
import type { Faq } from '../types'
import { Button } from '@/components/ui/button'

const router = useRouter()
const route = useRoute()
const loading = ref(true)
const faq = ref<Faq | null>(null)

onMounted(async () => {
    await fetchFaq()
})

async function fetchFaq() {
    loading.value = true
    try {
        const response = await axiosClient.get(`/faqs/${route.params.id}/get`)
        if (response.data && response.data.success) {
            faq.value = response.data.data
        }
    } catch (error) {
        console.error('Error fetching FAQ:', error)
        faq.value = null
    } finally {
        loading.value = false
    }
}

function editFaq() {
    router.push({ name: 'Upraviť FAQ', params: { id: route.params.id } })
}

function goToList() {
    router.push({ name: 'Zoznam FAQ' })
}
</script>

<template>
    <main class="flex-1 overflow-y-auto focus:outline-none">
        <div class="py-6">
            <div class="max-w-(--breakpoint-2xl) mx-auto">
                <div class="flex items-center justify-between">
                    <PageBreadcrumb page-title="Detail FAQ" />
                    <div class="flex space-x-4">
                        <Button @click="editFaq">
                            Upraviť
                        </Button>
                        <Button variant="outline" @click="goToList">
                            Späť na zoznam
                        </Button>
                    </div>
                </div>
            </div>
            <div class="max-w-(--breakpoint-2xl) mx-auto">
                <div class="py-4">
                    <div v-if="loading" class="text-center py-4">
                        <div
                            class="mx-auto size-6 animate-spin rounded-full border-2 border-solid border-gray-300 border-t-brand-500 dark:border-gray-700">
                        </div>
                        <p class="mt-2 text-sm text-gray-500 dark:text-gray-400">Načítavanie...</p>
                    </div>
                    <div v-else-if="!faq" class="text-center py-8">
                        <p class="text-gray-500 dark:text-gray-400">FAQ sa nenašlo</p>
                        <Button variant="outline" class="mt-4" @click="goToList">
                            Späť na zoznam
                        </Button>
                    </div>
                    <div v-else class="bg-white shadow-xs overflow-hidden sm:rounded-lg dark:bg-gray-900">
                        <div class="px-4 py-5 sm:px-6">
                            <h3 class="text-lg leading-6 font-medium text-gray-900 dark:text-white/90">{{ faq.title }}</h3>
                            <p class="mt-1 max-w-2xl text-sm text-gray-500 dark:text-gray-400">FAQ podrobnosti</p>
                        </div>
                        <div class="border-t border-gray-200 px-4 py-5 sm:p-6 dark:border-gray-800">
                            <p class="text-sm text-gray-900 whitespace-pre-wrap dark:text-white/90">{{ faq.content }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<style scoped>
/* Using global styles and Tailwind classes */
</style>
